import { makeStyles } from "tss-react/mui";
import { MiChip } from "@miplatform/components";
import { BID_STATUS } from "../../Bids/CreateBid/constants";

export function StatusChip({ status }: StatusChipProps) {
  const { classes, cx } = useStyles();

  return (
    <MiChip
      label={status}
      size="small"
      className={cx(
        classes.chip,
        status === BID_STATUS.ASSIGNMENT && classes.assignmentChip,
        status === BID_STATUS.SETUP && classes.setupChip,
        status === BID_STATUS.PRICING && classes.pricingChip,
        status === BID_STATUS.APPROVED && classes.approvedChip
      )}
    />
  );
}

const useStyles = makeStyles()((theme) => ({
  chip: {
    borderRadius: 2,
    height: 18,
    fontWeight: theme.fontWeight.regular,
    "& .MuiChip-label": {
      padding: theme.spacing(0, 1),
      fontSize: theme.fontSize.small,
    },
  },
  assignmentChip: {
    border: `1px solid ${theme.palette.caution.dark}`,
    color: theme.palette.caution.dark,
    backgroundColor: theme.palette.yellow.lightAccent,
  },
  pricingChip: {
    border: `1px solid ${theme.palette.info.dark}`,
    color: theme.palette.info.dark,
    backgroundColor: theme.palette.info.light,
  },
  setupChip: {
    border: `1px solid ${theme.palette.orange.dark}`,
    color: theme.palette.orange.dark,
    backgroundColor: theme.palette.orange.light,
  },
  approvedChip: {
    border: `1px solid ${theme.palette.green.dark}`,
    color: theme.palette.green.dark,
    backgroundColor: theme.palette.green.light,
  },
}));

interface StatusChipProps {
  status: string;
}
